"use client";

import React from "react";

import { PhoneLayout } from "@/features/previews/layouts/PhoneLayout";
import { CouponTemplateContent } from "./components";
import { useCouponData } from "./hooks";
import type { QRProps } from "@/contexts/QREditorContext/types";
import { handleCopyCouponCode } from "./utils";

import "./CouponTemplate.scss";

export const CouponTemplate = (props: QRProps<"coupon">) => {
  const {
    t,
    isInitialPreview,
    data,
    addressData,
    dateStatus,
    hasLogo,
    buttonColor,
    backgroundColor,
  } = useCouponData(props);

  const [isFlipped, setIsFlipped] = React.useState(false);

  if (!data) {
    return null;
  }

  const handleFlip = () => setIsFlipped(true);
  const handleCloseFlip = () => setIsFlipped(false);

  return (
    <PhoneLayout
      page="coupon"
      dataQA="preview-coupon-container"
      backgroundColor={backgroundColor}
      isInitPreview={isInitialPreview}
      hasIncludeBrowser
    >
      <CouponTemplateContent
        data={data}
        t={t}
        isInitialPreview={isInitialPreview}
        isFlipped={isFlipped}
        onFlip={handleFlip}
        onCloseFlip={handleCloseFlip}
        addressData={addressData}
        dateStatus={dateStatus}
        hasLogo={hasLogo}
        buttonColor={buttonColor}
        backgroundColor={backgroundColor}
        onCopyCode={handleCopyCouponCode}
      />
    </PhoneLayout>
  );
};
